import { Link } from "react-router-dom";
import { Facebook, Mail, MapPin, Phone } from "lucide-react";
import { LOGO_URL, ORG } from "../lib/constants";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-brand-charcoal text-brand-cream pt-20 pb-8 mt-24 relative overflow-hidden">
      <div className="absolute inset-0 grain-overlay opacity-40 pointer-events-none"></div>
      <div className="container-editorial relative">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="" className="h-12 w-12 rounded-full bg-white/5 p-1" />
              <div>
                <div className="font-serif text-xl">{ORG.name}</div>
                <div className="text-[11px] tracking-[0.2em] uppercase text-brand-peach/80">{ORG.tagline}</div>
              </div>
            </div>
            <p className="mt-5 text-sm text-brand-cream/70 leading-relaxed max-w-md">
              {ORG.mission}
            </p>
            <a
              href={ORG.donateUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-donate"
              className="mt-6 inline-flex items-center bg-brand-peach text-brand-charcoal rounded-full px-5 py-2.5 text-sm font-medium hover:bg-brand-peach/90 transition-colors"
            >
              Donate to our mission
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.24em] uppercase text-brand-peach/80 mb-4">Navigate</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" data-testid="footer-home" className="hover:text-brand-peach transition-colors">Home</Link></li>
              <li><Link to="/about" data-testid="footer-about" className="hover:text-brand-peach transition-colors">About</Link></li>
              <li><Link to="/programs" data-testid="footer-programs" className="hover:text-brand-peach transition-colors">Programs</Link></li>
              <li><Link to="/testimonials" data-testid="footer-testimonials" className="hover:text-brand-peach transition-colors">Stories</Link></li>
              <li><Link to="/apply" data-testid="footer-apply" className="hover:text-brand-peach transition-colors">Apply</Link></li>
              <li><Link to="/contact" data-testid="footer-contact" className="hover:text-brand-peach transition-colors">Contact</Link></li>
              <li><Link to="/privacy" data-testid="footer-privacy" className="hover:text-brand-peach transition-colors">Privacy Notice</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] tracking-[0.24em] uppercase text-brand-peach/80 mb-4">Reach Us</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-0.5 text-brand-peach" /><span>{ORG.address}</span></li>
              <li className="flex items-start gap-3"><Phone className="w-4 h-4 mt-0.5 text-brand-peach" /><a href={`tel:${ORG.phoneTel}`} className="hover:text-brand-peach">{ORG.phone}</a></li>
              <li className="flex items-start gap-3"><Mail className="w-4 h-4 mt-0.5 text-brand-peach" /><a href={`mailto:${ORG.email}`} className="hover:text-brand-peach break-all">{ORG.email}</a></li>
              <li className="flex items-start gap-3"><Facebook className="w-4 h-4 mt-0.5 text-brand-peach" /><a href={ORG.facebookUrl} target="_blank" rel="noreferrer" className="hover:text-brand-peach">Follow on Facebook</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-brand-cream/50">
          <div>© {new Date().getFullYear()} Hosea Ministries Foundation · All rights reserved.</div>
          <a
            href="https://builtby-ab.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="built-by-ab"
            className="text-[10px] tracking-[0.28em] uppercase opacity-70 hover:opacity-100 hover:text-brand-peach transition-opacity"
          >
            Built by AB
          </a>
        </div>
      </div>
    </footer>
  );
}
